export default __webpack_public_path__ + "static/media/noThumbnailFallback.21f68d4a.png";